// extracted by mini-css-extract-plugin
export default {"form":"SmForm_form__GdPBC","actions":"SmForm_actions__iGZ0m"};